// 引入浏览器样式重置css文件
import './common/css/reset.css'
// 引入公共样式
import './common/css/public.css'
// 引入机构
import './common/css/jigou.css'

import { createApp } from 'vue'
import App from './App.vue'
// 引入路由，提供页面间跳转功能
import router from './router'
// 引入Vuex
import store from './store'
// 引用element
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import plugins from './plugins'
import QiniuVideoPlayer from "@/components/QiniuVideoPlayer"

const vueScrollTo = require('vue-scrollto');
let scrollOptions = {
    container: "body", //滚动的容器
    duration: 500, //滚动时间
    easing: "ease", //缓动类型
    offset: -80, // 滚动时应应用的偏移量。此选项接受回调函数
    force: true, // 是否应执行滚动
    cancelable: true, // 用户是否可以取消滚动
    onStart: false, // 滚动开始时的钩子函数
    onDone: false, // 滚动结束时候的钩子函数
    onCancel: false, // 用户取消滚动的钩子函数
    x: false, // 是否要在x轴上也滚动
    y: true    // 是否要在y轴上滚动
};

const app = createApp(App);
app.component('QiniuVideoPlayer', QiniuVideoPlayer)
app.use(router);
app.use(store);
app.use(plugins);
app.use(ElementPlus);
app.use(vueScrollTo, scrollOptions);
// 执行挂载
app.mount('#app');
